var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpecialTick = function SvgSpecialTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.425 17.526C24.654 16.669 26 15.929 26 15c0-.929-1.346-1.67-1.575-2.526-.237-.886.552-2.199.102-2.975-.455-.788-1.99-.758-2.63-1.396-.638-.64-.608-2.175-1.396-2.63-.776-.45-2.089.34-2.975.102C16.669 5.346 15.929 4 15 4c-.93 0-1.67 1.346-2.526 1.575-.886.237-2.199-.552-2.975-.103-.788.456-.758 1.991-1.397 2.63-.639.64-2.174.61-2.63 1.397-.449.776.34 2.089.103 2.975C5.346 13.331 4 14.071 4 15c0 .93 1.346 1.67 1.575 2.526.237.886-.552 2.2-.103 2.975.456.788 1.991.758 2.63 1.397.64.639.61 2.174 1.397 2.63.776.449 2.089-.34 2.975-.103C13.331 24.654 14.071 26 15 26c.93 0 1.67-1.346 2.526-1.575.886-.237 2.199.552 2.975.103.788-.456.757-1.991 1.397-2.63.639-.64 2.174-.61 2.63-1.397.449-.776-.34-2.089-.103-2.975Z",
    fill: "#D64309"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19 12-5.5 6-2.5-2.727",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSpecialTick;